import { createFileRoute, Link } from "@tanstack/react-router";
import { Card } from "@/components/ui/card";
import { licenseTextOf, thirdPartyNotice } from "@/lib/licenses";

/** THIRD PARTY NOTICE – public, no login required. */
export const Route = createFileRoute("/licenses")({
  component: LicensesPage,
});

function LicensesPage() {
  const generatedAt = new Date(thirdPartyNotice.generatedAt).toLocaleDateString("pl-PL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="mx-auto w-full max-w-3xl px-6 py-10">
      <nav className="mb-6 text-sm">
        <Link to="/" className="underline-offset-2 hover:underline">
          ← Wróć do panelu
        </Link>
      </nav>

      <h1 className="text-2xl font-semibold">Licencje open source</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Panel powstał z użyciem {thirdPartyNotice.packages.length} pakietów open source. Poniżej
        znajdują się informacje o prawach autorskich i treści ich licencji.
      </p>
      <p className="mt-1 text-xs text-muted-foreground">Lista wygenerowana {generatedAt}</p>

      <div className="mt-6 space-y-2">
        {thirdPartyNotice.packages.map((pkg) => {
          const text = licenseTextOf(pkg);
          return (
            <Card key={`${pkg.name}@${pkg.version}`} className="px-4 py-3">
              <details>
                <summary className="cursor-pointer list-none">
                  <div className="font-medium">{pkg.name}</div>
                  <div className="text-xs text-muted-foreground">
                    {pkg.version} · {pkg.license}
                    {pkg.copyright ? ` · © ${pkg.copyright}` : null}
                  </div>
                </summary>
                <div className="mt-3 space-y-3 border-t pt-3">
                  {pkg.licenseExpression ? (
                    <p className="text-xs text-muted-foreground">
                      Podwójna licencja: {pkg.licenseExpression}
                    </p>
                  ) : null}
                  <pre className="whitespace-pre-wrap font-mono text-xs leading-relaxed">
                    {text ??
                      `Pakiet jest rozpowszechniany na licencji ${pkg.license}; pakiet nie zawiera tekstu licencji.`}
                  </pre>
                  {pkg.noticeText ? (
                    <>
                      <p className="text-xs font-semibold">NOTICE</p>
                      <pre className="whitespace-pre-wrap font-mono text-xs leading-relaxed">
                        {pkg.noticeText}
                      </pre>
                    </>
                  ) : null}
                  {pkg.repository ? (
                    <a
                      href={pkg.repository}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs underline underline-offset-2"
                    >
                      Kod źródłowy
                    </a>
                  ) : null}
                </div>
              </details>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
